import { Card, Divider } from "semantic-ui-react";

import { Link } from "react-router-dom";

import TodoAssignedTo from "./TodoAssignedTo";
import TodoContent from "./TodoContent";
import TodoHeader from "./TodoHeader";
import TodoProduction from "./TodoProduction";

export default function Todo({ todo, organization, managerOptions }) {
	const { content, users, userNames, url } = todo;

	const showContent = !!content;
	const showAssigned = organization && (users?.length > 0 || userNames?.length > 0);
	const isResolved = todo.resolved.status;
	const showDivider = showContent || showAssigned || isResolved;

	return (
		<Card
			as={!isResolved && Link}
			fluid
			style={{
				borderRadius: 5,
				cursor: "pointer",
				color: "var(--color-text)",
				border: isResolved ? "1px solid #21ba45" : null,
				boxShadow: isResolved && "none",
			}}
			to={url}
		>
			<TodoHeader todo={todo} managerOptions={managerOptions} />

			{showDivider && <Divider style={{ margin: "-2px 1em" }} />}

			<div style={{ padding: "1em" }}>
				{showContent && (
					<>
						<TodoProduction todo={todo} />
						<TodoContent todo={todo} />
					</>
				)}

				{showAssigned && <TodoAssignedTo todo={todo} />}
			</div>
		</Card>
	);
}
